export default {
  API_HOST: process.env.REACT_APP_API_HOST,
  MEDIA_HOST: process.env.REACT_APP_MEDIA_HOST,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
  SETTINGS_KEY: process.env.REACT_APP_SETTINGS_KEY,
  ...window.env,
};
